import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import SideMenu from "../../../components/menus/m-side";
import PhotoAlbum from "react-photo-album";
import photosInstallations from "../../../__params/tab-pages/leclub/tab-installations";
import { useNavHeight } from "../../../__utils/context/navheightprovider";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

// import optional lightbox plugins
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Slideshow from "yet-another-react-lightbox/plugins/slideshow";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/plugins/thumbnails.css";

const NosInstallations = () => {
  const [indexPhoto, setIndexPhoto] = useState(-1);
  const [tabImages, setTabImages] = useState([]);
  const { navbarHeight } = useNavHeight();

  const handlePhotoClicked =
    (id) =>
    ({ index }) => {
      // Récupérer les photos du bon groupe d'installations
      const imagesClicked = photosInstallations.filter(
        (item) => item.id === id,
      )[0].images;
      setTabImages(imagesClicked);

      setIndexPhoto(index);
    };

  return (
    <main role="main" className="mc-fond-clubhouse">
      <Container fluid className="gx-0">
        <Row className="gx-0">
          <Col
            md={3}
            className="gx-0"
            style={{
              position: "sticky",
              top: navbarHeight,
              zIndex: "1000",
            }}
          >
            <SideMenu />
          </Col>
          <Col md={9} className="m-auto">
            <h1 className="my-3 mc-rampart mc-rfs-2 mc-title text-center">
              Nos installations
            </h1>
            {photosInstallations.map((img) => {
              return (
                <div key={img.id} className="mc-container-club">
                  <Row className="mc-container-histoire1">
                    <Card className="border border-5 rounded-4 p-2 mc-card text-light">
                      <Card.Body className="p-0">
                        <Card.Title className="display-7 fw-bold text-center mb-3">
                          {img.title}
                        </Card.Title>
                        <PhotoAlbum
                          layout="rows"
                          photos={img.images}
                          onClick={handlePhotoClicked(img.id)}
                        />
                      </Card.Body>
                    </Card>
                  </Row>
                </div>
              );
            })}
            <Lightbox
              slides={tabImages}
              open={indexPhoto >= 0}
              index={indexPhoto}
              close={() => setIndexPhoto(-1)}
              // enable optional lightbox plugins
              plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
            />
          </Col>
        </Row>
      </Container>
    </main>
  );
};

export default NosInstallations;
